import type { AreaRoute } from "./areaRoute";
import {
  ComplianceReaders,
  CustodyReaders,
  OperationsPrincipals
} from "../../auth/roles";
import { lazyPage } from "../../lib/lazyPage";
const ApprovalsPage = lazyPage(() => import("../quality/ApprovalsPage"), "ApprovalsPage");
const As9100Page = lazyPage(() => import("../quality/As9100Page"), "As9100Page");
const CmmcPage = lazyPage(() => import("../quality/CmmcPage"), "CmmcPage");
const SspPage = lazyPage(() => import("../quality/CmmcPage"), "SspPage");
const IncidentsPage = lazyPage(() => import("../quality/IncidentsPage"), "IncidentsPage");
const IncidentDetailPage = lazyPage(() => import("../quality/IncidentDetailPage"), "IncidentDetailPage");
const FormsRegisterPage = lazyPage(() => import("../quality/FormsRegisterPage"), "FormsRegisterPage");
const RecordsRetentionPage = lazyPage(() => import("../quality/RecordsRetentionPage"), "RecordsRetentionPage");
const ValidationPage = lazyPage(() => import("../quality/ValidationPage"), "ValidationPage");

export {
  ApprovalsPage,
  As9100Page,
  CmmcPage,
  SspPage,
  IncidentsPage,
  IncidentDetailPage,
  FormsRegisterPage,
  RecordsRetentionPage,
  ValidationPage
};

export const qualityRoutes: AreaRoute[] = [
  {
    path: "/knowledge/incidents/:id",
    allow: OperationsPrincipals,
    element: <IncidentDetailPage />
  },
  {
    path: "/quality/incidents",
    allow: OperationsPrincipals,
    element: <IncidentsPage />
  },
  {
    path: "/quality/incidents/:id",
    allow: OperationsPrincipals,
    element: <IncidentDetailPage />
  },
  {
    path: "/admin/cmmc",
    allow: ComplianceReaders,
    element: <CmmcPage />
  },
  {
    path: "/admin/cmmc/ssp",
    allow: ComplianceReaders,
    element: <SspPage />
  },
  {
    path: "/admin/as9100",
    allow: ComplianceReaders,
    element: <As9100Page />
  },
  {
    path: "/admin/forms",
    allow: ComplianceReaders,
    element: <FormsRegisterPage />
  },
  {
    path: "/admin/records",
    allow: CustodyReaders,
    element: <RecordsRetentionPage />
  },
  {
    path: "/admin/validation",
    allow: ComplianceReaders,
    element: <ValidationPage />
  }
];